import { HoverCard } from "../../components/ui";

function HypothesisIcon() {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M4.5 4.75h11v7.5h-6l-3.5 3v-3H4.5z" />
      <path d="M7 8h6M7 10h4" />
    </svg>
  );
}

export default function HypothesisHoverCard({
  label,
  eyebrow,
  hypothesis,
}: {
  label: string;
  eyebrow: string;
  hypothesis: string;
}) {
  const value = hypothesis.trim();
  return (
    <HoverCard
      label={label}
      trigger={<HypothesisIcon />}
      className="run-hypothesis-hover__trigger"
    >
      <div className="run-hypothesis-hover">
        <span className="run-hypothesis-hover__eyebrow">{eyebrow}</span>
        <p>{value || "No hypothesis supplied."}</p>
      </div>
    </HoverCard>
  );
}
